import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";

function WhoWeAre() {
    return (
        <div className="landing-page-component">
            <FrontHeader />
            <div className="page-content pb-5">
                <div className="container-easy-market">
                    <div className="container">
                        {/* Titre principal */}
                        <h1 className="about-us-main-title">
                            Qui sommes-nous ?
                        </h1>

                        {/* Première section : Image + Texte */}
                        <div className="about-us-section">
                            <div className="row align-items-center">
                                {/* Image à gauche */}
                                <div className="col-md-6 col-lg-5">
                                    <div className="about-us-image-container">
                                        <img 
                                            src="/Amilink Contact.png" 
                                            alt="AMILINK - Qui sommes-nous"
                                            className="about-us-image"
                                        />
                                    </div>
                                </div>

                                {/* Texte à droite */}
                                <div className="col-md-6 col-lg-7">
                                    <div className="about-us-content">
                                        <p className="about-us-subtitle">
                                            QUI SOMMES-NOUS
                                        </p>
                                        <h2 className="about-us-brand-name">
                                            AMILINK
                                        </h2>
                                        <div className="about-us-description">
                                            <p>
                                                <strong>AMILINK</strong> est une marque de lingerie moderne, sensuelle et élégante.
                                            </p>
                                            <p>
                                                Nous proposons une sélection de lingeries, culottes, pyjamas, gaines, shapewear et sous-vêtements pensés pour sublimer la silhouette et accompagner les femmes dans leur féminité au quotidien.
                                            </p>
                                            <p>
                                                Notre mission : offrir des pièces confortables, raffinées et accessibles, qui mettent en valeur le corps et donnent confiance à chaque femme.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section Nos valeurs */}
                        <div className="about-us-values-section">
                            <h3 className="about-us-values-title">
                                Nos valeurs
                            </h3>
                            <div className="about-us-values-list">
                                <div className="about-us-value-item">
                                    <h4 className="about-us-value-name">
                                        Féminité
                                    </h4>
                                    <p className="about-us-value-description">
                                        Des pièces qui subliment votre silhouette et révèlent votre sensualité.
                                    </p>
                                </div>
                                <div className="about-us-value-item">
                                    <h4 className="about-us-value-name">
                                        Confort
                                    </h4>
                                    <p className="about-us-value-description">
                                        Des matières douces, agréables et adaptées au quotidien.
                                    </p>
                                </div>
                                <div className="about-us-value-item">
                                    <h4 className="about-us-value-name">
                                        Élégance
                                    </h4>
                                    <p className="about-us-value-description">
                                        Un style unique, moderne et raffiné, accessible à toutes.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Section Notre équipe */}
                        <div className="about-us-team-section">
                            <div className="about-us-team-header">
                                <div className="about-us-team-header-line"></div>
                                <p className="about-us-team-subtitle">
                                    QUI SOMMES-NOUS
                                </p>
                                <h3 className="about-us-team-title">
                                    Notre équipe
                                </h3>
                            </div>
                            <div className="about-us-team-members">
                                <div className="about-us-team-card">
                                    <div className="about-us-team-photo-container">
                                        <img 
                                            src="/WhatsApp Image 2025-04-08 at 18.01.34.png" 
                                            alt="Ami Collé Lo"
                                            className="about-us-team-photo"
                                        />
                                    </div>
                                    <h4 className="about-us-team-name">
                                        Ami Collé Lo
                                    </h4>
                                    <p className="about-us-team-role">
                                        Fondatrice & Agent de Sourcing principal
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Section Mot de la fondatrice */}
                        <div className="about-us-founder-section">
                            <div className="about-us-founder-header">
                                <p className="about-us-founder-subtitle">
                                    QUI SOMMES-NOUS
                                </p>
                                <div className="about-us-founder-title-container">
                                    <div className="about-us-founder-header-line"></div>
                                    <h3 className="about-us-founder-title">
                                        Mot de la fondatrice
                                    </h3>
                                </div>
                            </div>
                            <div className="about-us-founder-quote-card">
                                <blockquote className="about-us-founder-quote">
                                    « AMILINK est née d'une envie simple: offrir à chaque femme des dessous qui la font se sentir sexy, confiante et pleinement elle-même.
                                    Nos collections sont créées avec passion, amour.
                                    Je veux que chaque femme, quelle que soit sa morphologie, trouve chez AMILINK une pièce qui met en valeur ses courbes, et célèbre sa beauté naturelle.
                                    Merci à toutes celles qui nous inspirent chaque jour et donnent vie à l'âme de la marque. »
                                </blockquote>
                                <div className="about-us-founder-signature">
                                    <p className="about-us-founder-name">
                                        Ami Collé Lo,
                                    </p>
                                    <p className="about-us-founder-role">
                                        Fondatrice d'Amilink
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </div>
    );
}

export default WhoWeAre;